import { createTheme } from '@mui/material/styles'
import type { PaletteMode } from '@mui/material'

export const createAppTheme = (mode: PaletteMode) => {
  const isDark = mode === 'dark'

  return createTheme({
    typography: {
      fontFamily: 'Anuphan, sans-serif',
      subtitle1: {
        fontSize: '22px',
        lineHeight: '28px',
        fontWeight: 700,
      },
    },
    palette: {
      mode,
      primary: {
        main: '#DE2826',
        dark: '#B90810',
        light: '#ED6C02',
      },
      secondary: {
        main: isDark ? '#EFEFEF' : '#000000',
        light: '#BCBCBC',
        dark: '#939090',
      },
      error: {
        main: '#C74C3F',
        light: isDark ? 'rgba(222,40,38,0.15)' : '#FCE9E9',
      },
      success: {
        main: '#33B15B',
        light: isDark ? 'rgba(51,177,91,0.15)' : '#F5FEE9',
      },
      warning: {
        main: '#ED6C02',
        light: isDark ? 'rgba(237,108,2,0.15)' : '#FFF3E0',
      },
      info: {
        main: '#1683B7',
        light: isDark ? 'rgba(22,131,183,0.15)' : '#E3F2FD',
      },
      background: {
        default: isDark ? '#1A1A1A' : '#FAFAFA',
        paper: isDark ? '#242424' : '#FFFFFF',
      },
      text: {
        primary: isDark ? '#F0EFEF' : '#000000',
        secondary: isDark ? '#ABABAB' : '#6B6B6B',
      },
      divider: isDark ? '#3A3A3A' : '#E5E5E5',
    },
    components: {
      MuiDivider: {
        styleOverrides: {
          root: {
            borderColor: isDark ? '#3A3A3A' : '#bcbcbc',
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          root: {
            borderBottom: `1px solid ${isDark ? '#3A3A3A' : '#BCBCBC'}`,
          },
          indicator: {
            height: '4px',
            borderRadius: '8px 8px 0 0',
            backgroundColor: '#DE2826',
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            fontSize: '1rem',
          },
        },
      },
      MuiTab: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            fontWeight: 500,
          },
        },
      },
      MuiButton: {
        variants: [
          {
            props: { variant: 'contained' },
            style: {
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 500,
              padding: '10px 24px',
              borderRadius: '16px',
              backgroundColor: '#DE2826',
              boxShadow: 'none',
              color: '#FFFFFF',
              '&:hover': {
                backgroundColor: '#B71C1C',
              },
            },
          },
          {
            props: { variant: 'outlined' },
            style: {
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 500,
              padding: '10px 24px',
              borderRadius: '16px',
              borderColor: isDark ? '#555555' : '#C9C5C6',
              boxShadow: 'none',
              color: '#DE2826',
              '&:hover': {
                borderColor: '#B71C1C',
                color: '#B71C1C',
              },
            },
          },
        ],
      },
    },
  })
}

export default createAppTheme('light')
